import { useTranslation } from 'react-i18next';
import { PurchaseManagement } from './PurchaseManagement';

interface SalesOverviewPanelProps {
  onClose: () => void;
}

// "Przegląd sprzedaży" opened from the Operacje tile — the former Zakupy tab
// (PurchaseManagement) inside the portal's dark-frame modal (design system §4.4).
export function SalesOverviewPanel({ onClose }: SalesOverviewPanelProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-brand-primary-deep rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border-strong">
          <h2 className="text-lg font-semibold text-white">
            {t('operationsPage.salesOverviewTitle', 'Przegląd sprzedaży')}
          </h2>
          <button
            onClick={onClose}
            aria-label={t('common.close', 'Zamknij')}
            className="text-white/70 hover:text-white transition-colors"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 min-h-0 overflow-y-auto">
          <PurchaseManagement embedded />
        </div>
      </div>
    </div>
  );
}
